export default __webpack_public_path__ + "static/media/electronics.14fc5c6b.PNG";